import Vue from 'vue';
import VueStore from 'vuex';
import authenService from '@/utils/authen';
import {
  LOGIN,
  LOGOUT,
  SET_START_LOADING_MAIN_SCREEN,
  SET_STOP_LOADING_MAIN_SCREEN,
  SET_START_LOADING_ALL_SCREEN,
  SET_STOP_LOADING_ALL_SCREEN,
  ADD_INFO_USER,
  REMOVE_INFO_USER,
  TRIGGER_ADD_LIGHT,
  OFF_FORM_ADD_LIGHT,
  DETERMIN_POIN_MAP,
  ADD_NEW_LIGHT,
  UPDATE_LIGHT,
  DELETE_LIGHT,
  UPDATE_LIGHT_VALUE,
  DELETE_ALL_LIGHT,
  LOAD_LIST_LIGHT,
  HIDE_MENU,
  SHOW_MENU
} from './mutation-types';

import mapDevice from './modules/mapDevice';
import drawMap from './modules/drawMap';

Vue.use(VueStore);

export default new VueStore.Store({
  strict: !process.env.NODE_ENV !== 'production',
  // strict: true,
  state: {
    logged: false,
    infoUser: {},
    flagLoadingMainScreen: 0,
    flagLoadingAllScreen: 0,
    modeView: '',
    isCollapse: false,
    isCreateLight: false,
    infoNewPoint: {},
    listLightMiniMap: [],
    listStrategy: []
  },

  getters: {
    logged: state => state.logged,
    infoUser: state => state.infoUser,
    flagLoadingMainScreen: state => state.flagLoadingMainScreen,
    flagLoadingAllScreen: state => state.flagLoadingAllScreen,
    modeView: state => state.modeView,
    isCollapse: state => state.isCollapse,
    isCreateLight: state => state.isCreateLight,
    infoNewPoint: state => state.infoNewPoint,
    listLightMiniMap: state => state.listLightMiniMap,
    listStrategy: state => state.listStrategy
  },

  actions: {
    LOGIN ({ commit, dispatch }) {
      commit(LOGIN);
    },

    LOGOUT ({ commit, dispatch }) {
      commit(LOGOUT);
    },

    ADD_INFO_USER ({ commit, dispatch }, payload) {
      commit(ADD_INFO_USER, payload);
    },

    REMOVE_INFO_USER ({ commit, dispatch }) {
      commit(REMOVE_INFO_USER);
    },

    SET_START_LOADING_ALL_SCREEN ({ commit, dispatch }) {
      commit(SET_START_LOADING_ALL_SCREEN);
    },

    SET_STOP_LOADING_ALL_SCREEN ({ commit, dispatch }) {
      commit(SET_STOP_LOADING_ALL_SCREEN);
    },

    SET_START_LOADING_MAIN_SCREEN ({ commit, dispatch }) {
      commit(SET_START_LOADING_MAIN_SCREEN);
    },

    SET_STOP_LOADING_MAIN_SCREEN ({ commit, dispatch }) {
      commit(SET_STOP_LOADING_MAIN_SCREEN);
    },

    SET_MODE_VIEW ({ commit, dispatch }, payload) {
      commit('SET_MODE_VIEW', payload);
    },

    SET_COLLAPSE_MENU ({ commit, dispatch }) {
      commit('setCollapseMenu');
    },
    HIDE_MENU ({ commit, dispatch }) {
      commit(HIDE_MENU);
    },
    SHOW_MENU ({ commit, dispatch }) {
      commit(SHOW_MENU);
    },

    // CODE NEW
    TRIGGER_ADD_LIGHT ({commit, dispatch}) {
      commit(TRIGGER_ADD_LIGHT);
    },

    OFF_FORM_ADD_LIGHT ({commit, dispatch}) {
      commit(OFF_FORM_ADD_LIGHT);
    },

    DETERMIN_POIN_MAP ({commit, dispatch}, payload) {
      commit(DETERMIN_POIN_MAP, payload);
    },

    ADD_NEW_LIGHT ({commit, dispatch}, payload) {
      commit(ADD_NEW_LIGHT, payload);
    },

    UPDATE_LIGHT ({commit, dispatch}, payload) {
      commit(UPDATE_LIGHT, payload);
    },

    UPDATE_LIGHT_VALUE ({commit, dispatch}, payload) {
      commit(UPDATE_LIGHT_VALUE, payload);
    },

    DELETE_LIGHT ({commit, dispatch}, payload) {
      commit(DELETE_LIGHT, payload);
    },

    DELETE_ALL_LIGHT ({commit, dispatch}, payload) {
      commit(DELETE_ALL_LIGHT, payload);
    },
    LOAD_LIST_LIGHT ({commit, dispatch}, payload) {
      commit(LOAD_LIST_LIGHT, payload);
    }

    // Dao code
    // ADD_NEW_STRATEGY ({commit, dispatch}, payload) {
    //   commit(ADD_NEW_STRATEGY, payload);
    // },
    // REMOVE_STRATEGY ({commit, dispatch}, payload) {
    //   commit(REMOVE_STRATEGY, payload);
    // },
    // CHANGE_TIME_START ({commit, dispatch}, payload) {
    //   commit(CHANGE_TIME_START, payload);
    // },
    // CHANGE_TIME_END ({commit, dispatch}, payload) {
    //   commit(CHANGE_TIME_END, payload);
    // },
    // CHANGE_DIRECT_START ({commit, dispatch}, payload) {
    //   commit(CHANGE_DIRECT_START, payload);
    // },
    // CHANGE_DIRECT_COUNT ({commit, dispatch}, payload) {
    //   commit(CHANGE_DIRECT_COUNT, payload);
    // },
    // CHANGE_WALK_START ({commit, dispatch}, payload) {
    //   commit(CHANGE_WALK_START, payload);
    // },
    // CHANGE_WALK_COUNT ({commit, dispatch}, payload) {
    //   commit(CHANGE_WALK_COUNT, payload);
    // },
    // CHANGE_NUM_PHASE ({commit, dispatch}, payload) {
    //   commit(CHANGE_NUM_PHASE, payload);
    // },
    // CLEAR_STRATEGY ({commit, dispatch}) {
    //   commit(CLEAR_STRATEGY);
    // }
  },

  mutations: {
    [LOGIN] (state) {
      state.logged = true;
    },

    [LOGOUT] (state) {
      state.logged = false;
      authenService.removeToken();
      authenService.remove('vms_username');
      authenService.remove('vms_listDevices');
      authenService.remove('vms_role');
    },

    [ADD_INFO_USER] (state, payload) {
      state.infoUser = payload;
    },

    [REMOVE_INFO_USER] (state) {
      state.infoUser = {};
    },

    [SET_START_LOADING_MAIN_SCREEN] (state) {
      state.flagLoadingMainScreen++;
    },

    [SET_STOP_LOADING_MAIN_SCREEN] (state) {
      state.flagLoadingMainScreen--;
    },

    [SET_START_LOADING_ALL_SCREEN] (state) {
      state.flagLoadingAllScreen++;
    },

    [SET_STOP_LOADING_ALL_SCREEN] (state) {
      state.flagLoadingAllScreen--;
    },

    SET_MODE_VIEW (state, payload) {
      state.modeView = payload;
    },

    setCollapseMenu (state) {
      state.isCollapse = !state.isCollapse;
    },

    HIDE_MENU (state) {
      state.isCollapse = true;
    },

    SHOW_MENU (state) {
      state.isCollapse = false;
    },

    TRIGGER_ADD_LIGHT (state) {
      state.isCreateLight = true;
    },

    OFF_FORM_ADD_LIGHT (state) {
      state.isCreateLight = false;
    },

    DETERMIN_POIN_MAP (state, payload) {
      state.infoNewPoint = payload;
    },

    ADD_NEW_LIGHT (state, payload) {
      let max = -1;
      if (state.listLightMiniMap && state.listLightMiniMap !== []) {
        state.listLightMiniMap.forEach((item) => {
          if (item.id >= max) max = parseInt(item.id);
        });
      } else state.listLightMiniMap = [];
      if (max === -1) payload.id = 1;
      else payload.id = max + 1;
      state.listLightMiniMap.push(payload);
    },

    LOAD_LIST_LIGHT (state, payload) {
      // let id = parseInt(payload.id) - 1;
      // payload.id = id;
      state.listLightMiniMap.push(payload);
    },

    UPDATE_LIGHT (state, payload) {
      let x = Object.assign([], state.listLightMiniMap);
      x.forEach((element, index) => {
        if (element.id === payload.id) {
          x[index] = payload;
        }
      });
      state.listLightMiniMap = Object.assign([], x);
    },

    UPDATE_LIGHT_VALUE (state, payload) {
      let x = [];
      if (state.listLightMiniMap) {
        state.listLightMiniMap.forEach((item) => {
          let _item = Object.assign({}, item);
          _item.value = payload.phaseRemainCounter[parseInt(_item.phase) - 1];
          _item.status = payload.phaseStatus[parseInt(_item.phase) - 1];
          x.push(_item);
        });
      } else state.listLightMiniMap = [];
      state.listLightMiniMap = Object.assign([], x);
    },

    DELETE_LIGHT (state, payload) {
      let x = [];
      if (state.listLightMiniMap) {
        state.listLightMiniMap.forEach((element) => {
          if (element.id !== payload.id) {
            x.push(element);
          }
        });
      } else state.listLightMiniMap = [];
      state.listLightMiniMap = Object.assign([], x);
    },

    DELETE_ALL_LIGHT (state, payload) {
      state.listLightMiniMap = [];
    }

    // Dao code
    // ADD_NEW_STRATEGY (state, payload) {
    //   var check = 1;
    //   state.listStrategy.forEach(item => {
    //     if (payload === item.name) {
    //       check = 0;
    //     }
    //   });
    //   if (state.listStrategy.length >= 7) {
    //     check = 0;
    //   };
    //   if (payload !== '' & check === 1) {
    //     state.listStrategy.push({
    //       name: payload,
    //       time: []
    //     });
    //     var r = state.listStrategy.length;
    //     for (let i = 0; i < 8; i++) {
    //       state.listStrategy[r - 1].time.push(
    //         {
    //           name: payload + (i + 1),
    //           start: null,
    //           end: null,
    //           phaseDirect: [],
    //           phaseWalk: []
    //         }
    //       );
    //       var t = state.listStrategy[r - 1].time.length;
    //       for (let j = 0; j < 8; j++) {
    //         state.listStrategy[r - 1].time[t - 1].phaseDirect.push({
    //           name: 'P' + (j + 1),
    //           start: null,
    //           count: null
    //         });
    //         state.listStrategy[r - 1].time[t - 1].phaseWalk.push({
    //           name: 'P' + (j + 1),
    //           start: null,
    //           count: null
    //         });
    //       }
    //     }
    //   }
    // },
    // REMOVE_STRATEGY (state, payload) {
    //   state.listStrategy.splice(payload, 1);
    // },
    // CHANGE_TIME_START (state, payload) {
    //   state.listStrategy[payload.index].time[payload.periodSelected].start = payload.start;
    // },
    // CHANGE_TIME_END (state, payload) {
    //   state.listStrategy[payload.index].time[payload.periodSelected].end = payload.end;
    // },
    // CHANGE_DIRECT_START (state, payload) {
    //   state.listStrategy[payload.index].time[payload.periodSelected].phaseDirect[payload.directSelected].start = payload.start;
    // },
    // CHANGE_DIRECT_COUNT (state, payload) {
    //   state.listStrategy[payload.i].time[payload.c].phaseDirect[payload.a].count = payload.b;
    // },
    // CHANGE_WALK_START (state, payload) {
    //   state.listStrategy[payload.i].time[payload.c].phaseWalk[payload.a].start = payload.b;
    // },
    // CHANGE_WALK_COUNT (state, payload) {
    //   state.listStrategy[payload.i].time[payload.c].phaseWalk[payload.a].count = payload.b;
    // },
    // CHANGE_NUM_PHASE (state, payload) {
    //   let r = state.listStrategy[payload.index].time[payload.periodSelected].phaseDirect.length;
    //   if (r > payload.numPhase) {
    //     state.listStrategy[payload.index].time[payload.periodSelected].phaseDirect.splice(payload.numPhase);
    //     state.listStrategy[payload.index].time[payload.periodSelected].phaseWalk.splice(payload.numPhase);
    //   }
    //   if (r < payload.numPhase) {
    //     for (let i = r + 1; i <= payload.numPhase; i++) {
    //       state.listStrategy[payload.index].time[payload.periodSelected].phaseDirect.push(
    //         {
    //           name: 'P' + i,
    //           start: null,
    //           count: null
    //         }
    //       );
    //       state.listStrategy[payload.index].time[payload.periodSelected].phaseWalk.push(
    //         {
    //           name: 'P' + i,
    //           start: null,
    //           count: null
    //         }
    //       );
    //     }
    //   }
    // },
    // CLEAR_STRATEGY (state) {
    //   state.listStrategy = [];
    // }
  },

  modules: {
    mapDevice,
    drawMap
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js